import { Page } from '@optools/components/layout/page';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/audit')({
  beforeLoad: authorizedRouteLoader('audit'),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page
      links={[
        { label: 'Audits', to: '/audit/audits' },
        { label: 'Schedule', to: '/audit/schedule' },
      ]}
      title="Audit & Logging"
    />
  );
}
